import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import { rescheduleBooking } from '../../../api/sportaloka-client';
import { useParams } from 'react-router-dom';

const RescheduleModal = ({ resetData }) => {
  const { id } = useParams();
  const [date, setDate] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = () => {
    if (!date) {
      Swal.fire({
        title: 'Gagal!',
        text: `Alasan penjadwalan ulang wajib diisi`,
        icon: 'error',
        confirmButtonText: 'Tutup'
      });
      return false;
    }
    Swal.fire({
      title: 'Apakah anda yakin ingin menjadwalkan ulang pesanan ini?',
      text: 'Aksi ini tidak dapat dikembalikan',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Ya',
      cancelButtonText: 'Tidak'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setLoading(true);
          await rescheduleBooking(id, date);
          document.getElementById('closeModalReschedule').click();
          resetData();
          Swal.fire({
            title: 'Berhasil!',
            text: `Jadwal baru berhasil diajukan`,
            icon: 'success',
            confirmButtonText: 'Tutup'
          });
          setLoading(false);
        } catch (error) {
          Swal.fire({
            title: 'Gagal!',
            text: `Periksa koneksi internet anda`,
            icon: 'error',
            confirmButtonText: 'Tutup'
          });
          setLoading(false);
        }
      }
    });
  };

  useEffect(() => {
    const handleModalHidden = () => {
      setDate('');
    };

    const modalElement = document.getElementById('rescheduleBookingModal');
    modalElement.addEventListener('hidden.bs.modal', handleModalHidden);

    return () => {
      modalElement.removeEventListener('hidden.bs.modal', handleModalHidden);
    };
  }, []);
  return (
    <div className="modal" tabIndex="-1" id="rescheduleBookingModal">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title fw-600 text-16">Penjadwalan Ulang</h5>
            <button
              id="closeModalReschedule"
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <label className="fw-500 text-14" htmlFor="">
              Tanggal Penjadwalan Ulang
            </label>
            <input
              value={date}
              type="date"
              onChange={(e) => setDate(e.target.value)}
              className="form-control"
              style={{ resize: 'none', marginTop: 8, backgroundColor: '#f2f2f2' }}
            />
          </div>
          <div className="modal-footer d-flex justify-content-center">
            <button
              disabled={loading}
              onClick={handleSubmit}
              type="button"
              className="btn btn-primary bg-blue-1 rounded-1 fw-600">
              {loading ? 'Loading...' : 'Submit'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RescheduleModal;
